import { useCallback, useState } from 'react';
import { sendDinerWelcomeEmail } from 'src/components/enterprise/Parents/Admin/functions/sendDinerWelcomeEmail';
import {
  SdkErrorResponse,
  pushErrorFromAPI,
  pushSuccess,
} from 'src/utilities/notifications';
import { IErrorResponse } from 'src/utilities/shared-types';

export type DinerWelcomeEmailProps = {
  corpId: string;
  dinerId: string;
};

export type UseSendWelcomeEmailProps = {
  corpId: string;
  dinerId: string;
};

export type UseSendWelcomeEmailReturn = {
  sendWelcomeEmail: (corpId: string, dinerId: string) => Promise<void>;
  isLoading: boolean;
  sentWelcomeEmail: boolean;
};

export const useSendWelcomeEmail = (): UseSendWelcomeEmailReturn => {
  const [isLoading, setIsLoading] = useState<boolean>();
  const [sentWelcomeEmail, setSentWelcomeEmail] = useState<boolean>();

  const handleSuccess = async () => {
    pushSuccess('Your welcome email was successfully sent.');
    setIsLoading(false);
    setSentWelcomeEmail(true);
  };

  const handleError = (error?: IErrorResponse | SdkErrorResponse) => {
    pushErrorFromAPI(error, {
      fallbackMessage: 'Your welcome email was not sent. Try again.',
    });
    setIsLoading(false);
    setSentWelcomeEmail(false);
  };

  const sendWelcomeEmail = useCallback<
    (corpId: string, dinerId: string) => Promise<void>
  >(async (corpId, dinerId) => {
    try {
      setIsLoading(true);

      await sendDinerWelcomeEmail(corpId, dinerId);

      handleSuccess();
    } catch (error) {
      handleError();
    }
  }, []);

  return {
    sendWelcomeEmail,
    isLoading,
    sentWelcomeEmail,
  };
};
